module.exports = __webpack_public_path__ + "static/media/McKinseySans-LightItalic.133c9d69.woff";